import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { APISD } from "../../../../../config/apisd";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import PromotionModal from "./modal/promotion";
import LanjutSemesterModal from "./modal/lanjut-semester";
// import ModalUpdate from "./modal/update";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserGraduate,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import PreviewFoto, { StudentAvatar, studentPhoto } from "./modal/preview-foto";
import { PulseLoader } from "react-spinners";
import Pagination from "../../../../components/pagination_new";
import ModalSwitchStudent from "./modal/pindah-kelas";

export default function Rombel() {
  document.title = "Rombel";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");

  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(true);
  const [loadingSchool, setLoadingSchool] = useState(false);

  const firstLoadDone = useRef(false);
  const filterRevision = useRef(0);
  const fetchingRef = useRef(false);

  const [id, setId] = useState();
  const [modalAdd, setModalAdd] = useState(false);
  const [modalLanjutSemester, setModalLanjutSemester] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [modalSwitchStudent, setModalSwitchStudent] = useState(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);

  const [previewStudent, setPreviewStudent] = useState(null);

  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);

  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [getData, setGetData] = useState([]);
  const [dataWalas, setDataWalas] = useState(null);
  const semesterDataCache = useRef({});

  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [hasSearched, setHasSearched] = useState(false);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [selectedAcademicYearId, setSelectedAcademicYearId] = useState("");

  const [formFilter, setFormFilter] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
    ysb_teacher_id: "",
  });

  const location = useLocation();

  const [, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (level === "developer" || level === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });
      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
    } else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate, setPermission]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const collator = useMemo(
    () =>
      new Intl.Collator("id", {
        numeric: true,
        sensitivity: "base",
      }),
    []
  );

  const safeStr = (value) =>
    value === null || value === undefined ? "" : String(value);

  // Urutan jenjang sekolah: SD, SMP, lalu SMA (termasuk SDIA/SMPIA/SMAIA).
  const schoolOrder = (school) => {
    const label = String(school?.school_name || school?.school_code || "").toUpperCase().trim();
    if (/(^|[^A-Z])SD/.test(label)) return 0;
    if (/(^|[^A-Z])SMP/.test(label)) return 1;
    if (/(^|[^A-Z])SMA/.test(label)) return 2;
    return 3;
  };

  // Filter dependencies: Cabang -> Sekolah -> Tingkatan -> Kelas.
  useEffect(() => {
    let cancelled = false;
    const loadOptions = async () => {
      setLoading(true);
      try {
        const [branchRes, semesterRes, yearRes] = await Promise.all([
          APIMS.get(`/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`, fetchParams),

          APIMS.get(`/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`, fetchParams),

          APIMS.get(`/api/academic-years?page=${page}&limit=${limit}&ascending=${descending}`, fetchParams),
        ]);
        if (cancelled) return;
        const branches = branchRes?.data?.data || [];
        const semesters = semesterRes?.data?.data || [];
        const years = yearRes?.data?.data || [];
        const active = semesters.find((item) => Number(item.status) === 1) || semesters[0];
        const year = years.find((item) =>
          String(item.id) === String(active?.ysb_academic_year_id) ||
          (active?.name_year && String(item.name_year) === String(active.name_year))
        );
        setGetDataBranch(branches);
        setGetDataSemesterMap(semesters);
        setAcademicYears(years);
        setSelectedAcademicYearId(String(year?.id || active?.ysb_academic_year_id || ""));
        setFormFilter((old) => ({ ...old,
          ysb_branch_id: branches[0]?.branch_code || "",
          ysb_semester_id: active?.id || "",
        }));
      } catch (error) {
        if (!cancelled) swal({ title: "Gagal", text: error?.response?.data?.message || "Gagal memuat filter rombel", icon: "error" });
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    loadOptions();
    return () => { cancelled = true; };
  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    let cancelled = false;
    const branchId = formFilter.ysb_branch_id;
    if (!branchId) return;
    const loadSchools = async () => {
      setLoadingSchool(true);
      try {
        const response = await APIMS.get(`/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`, fetchParams);

        if (cancelled) return;
        
        let schools = response?.data?.data || [];
        if (["developer", "superadmin"].includes(storageLevel))
          schools = schools.filter((item) => String(item.ysb_branch_id) === String(branchId));
        if (branchId === "BKS") schools = schools.filter((item) => item.school_code !== "BASEMENT_BEKASI");
        schools = [...schools].sort((a, b) => schoolOrder(a) - schoolOrder(b) || collator.compare(a.school_name || "", b.school_name || ""));
        setGetDataSchool(schools);
        setFormFilter((old) => ({ ...old, ysb_school_id: schools[0]?.school_code || "", ysb_grade_level_id: "", ysb_kelas_id: "" }));
      } catch (error) {
        if (!cancelled) {
          setGetDataSchool([]);
          setFormFilter((old) => ({ ...old, ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "" }));
          swal({ title: "Gagal", text: error?.response?.data?.message || "Gagal memuat sekolah", icon: "error" });
        }
      } finally { if (!cancelled) setLoadingSchool(false); }
    };
    loadSchools();
    return () => { cancelled = true; };
  }, [formFilter.ysb_branch_id, ascending, collator, fetchParams, limit, page, storageLevel]);

  useEffect(() => {
    let cancelled = false;
    const schoolId = formFilter.ysb_school_id;
    const branchId = formFilter.ysb_branch_id;
    if (!schoolId) { setLoadingLevel(false); return; }
    const loadLevels = async () => {
      setLoadingLevel(true);
      try {
        const response = await APIMS.get(`/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`, fetchParams);
        if (cancelled) return;
        const school = getDataSchool.find((item) => String(item.school_code) === String(schoolId));
        const levels = (response?.data?.data || [])
          .filter((item) =>
            (String(item.ysb_school_id) === String(schoolId) ||
              (school?.id != null && String(item.ysb_school_id) === String(school.id))) &&
            String(item.ysb_branch_id) === String(branchId)
          )
          .sort((a, b) => collator.compare(a.name_level || "", b.name_level || ""));
        setGetDataLevel(levels);
        setFormFilter((old) => ({ ...old, ysb_grade_level_id: levels[0]?.id || "", ysb_kelas_id: "" }));
      } catch (error) {
        if (!cancelled) {
          setGetDataLevel([]);
          setFormFilter((old) => ({ ...old, ysb_grade_level_id: "", ysb_kelas_id: "" }));
          swal({ title: "Gagal", text: error?.response?.data?.message || "Gagal memuat tingkatan", icon: "error" });
        }
      } finally { if (!cancelled) setLoadingLevel(false); }
    };
    loadLevels();
    return () => { cancelled = true; };
  }, [formFilter.ysb_school_id, formFilter.ysb_branch_id, getDataSchool, ascending, collator, fetchParams, limit, page, storageLevel]);

  useEffect(() => {
    let cancelled = false;
    const gradeId = formFilter.ysb_grade_level_id;
    const schoolId = formFilter.ysb_school_id;
    const branchId = formFilter.ysb_branch_id;
    if (!gradeId) { setLoadingKelas(false); return; }
    const loadClasses = async () => {
      setLoadingKelas(true);
      try {
        const response = await APIMS.get(`/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`, fetchParams);
        if (cancelled) return;
        const school = getDataSchool.find((item) => String(item.school_code) === String(schoolId));
        const classes = (response?.data?.data || []).filter((item) =>
          String(item.ysb_grade_level_id) === String(gradeId) &&
          (String(item.ysb_school_id) === String(schoolId) ||
            (school?.id != null && String(item.ysb_school_id) === String(school.id))) &&
          String(item.ysb_branch_id) === String(branchId)
        ).sort((a, b) => collator.compare(a.name_kelas || "", b.name_kelas || ""));
        setGetDataKelas(classes);
        setFormFilter((old) => ({ ...old, ysb_kelas_id: classes[0]?.id || "" }));
      } catch (error) {
        if (!cancelled) {
          setGetDataKelas([]);
          setFormFilter((old) => ({ ...old, ysb_kelas_id: "" }));
          swal({ title: "Gagal", text: error?.response?.data?.message || "Gagal memuat kelas", icon: "error" });
        }
      } finally { if (!cancelled) setLoadingKelas(false); }
    };
    loadClasses();
    return () => { cancelled = true; };
  }, [formFilter.ysb_grade_level_id, formFilter.ysb_school_id, formFilter.ysb_branch_id, getDataSchool, ascending, collator, fetchParams, limit, page, storageLevel]);

  const activeSemester = getDataSemesterMap.find((item) => Number(item.status) === 1);
  const activeAcademicYear = academicYears.find((year) =>
    String(year.id) === String(activeSemester?.ysb_academic_year_id) ||
    (activeSemester?.name_year && String(year.name_year) === String(activeSemester.name_year))
  );
  const semesterOptions = useMemo(() => {
    const year = academicYears.find((item) => String(item.id) === String(selectedAcademicYearId));
    return getDataSemesterMap.filter((item) =>
      String(item.ysb_academic_year_id) === String(selectedAcademicYearId) ||
      (year && String(item.name_year) === String(year.name_year))
    ).sort((a, b) => Number(a.semester) - Number(b.semester));
  }, [academicYears, getDataSemesterMap, selectedAcademicYearId]);
  const selectedSemester = semesterOptions.find((item) => String(item.id) === String(formFilter.ysb_semester_id));
  const filtersLoading = loading || loadingSchool || loadingLevel || loadingKelas;
  const complete = !!selectedAcademicYearId && !!selectedSemester &&
    !!formFilter.ysb_branch_id && !!formFilter.ysb_school_id &&
    !!formFilter.ysb_grade_level_id && !!formFilter.ysb_kelas_id && !filtersLoading;

  const GetResponseData = useCallback(async () => {
    if (!complete || fetchingRef.current) return false;
    const revision = filterRevision.current;
    fetchingRef.current = true;
    setIsFetching(true);
    try {
      // Load both semesters together; switching tabs never requests data.
      const results = await Promise.all(semesterOptions.map(async (semester) => {
        const response = await APISD.post("/api/student-rombels", {
          ysb_academic_year_id: selectedAcademicYearId,
          ysb_semester_id: semester.id,
          ysb_grade_level_id: formFilter.ysb_grade_level_id,
          ysb_school_id: formFilter.ysb_school_id,
          ysb_branch_id: formFilter.ysb_branch_id,
          ysb_kelas_id: formFilter.ysb_kelas_id,
        }, fetchParams);
        const result = response?.data?.data || {};
        return [String(semester.id), {
          students: Array.isArray(result.students) ? result.students : [],
          walas: Array.isArray(result.walas) ? result.walas : [],
        }];
      }));
      if (revision !== filterRevision.current) return false;
      semesterDataCache.current = Object.fromEntries(results);
      const current = semesterDataCache.current[String(formFilter.ysb_semester_id)];
      setGetData(current?.students || []);
      setDataWalas(current?.walas || []);
      setHasSearched(true);
      setIsFilterDirty(false);
      return true;
    } catch (error) {
      if (revision !== filterRevision.current) return false;
      semesterDataCache.current = {};
      setGetData([]);
      setDataWalas(null);
      setHasSearched(false);
      setIsFilterDirty(true);
      swal({ title: "Gagal", text: error?.response?.data?.message || "Gagal mengambil data murid", icon: "error" });
      return false;
    } finally {
      fetchingRef.current = false;
      setIsFetching(false);
    }
  }, [complete, semesterOptions, selectedAcademicYearId, formFilter.ysb_semester_id, formFilter.ysb_grade_level_id, formFilter.ysb_school_id, formFilter.ysb_branch_id, formFilter.ysb_kelas_id, fetchParams]);

  useEffect(() => {
    if (complete && !firstLoadDone.current && !isFilterDirty) {
      firstLoadDone.current = true;
      GetResponseData();
    }
  }, [complete, isFilterDirty, GetResponseData]);

  useEffect(() => {
    setSelectedTab(getData[0]?.data_element?.[0]?.name_element || null);
  }, [getData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    filterRevision.current += 1;
    semesterDataCache.current = {};
    if (name === "ysb_academic_year_id") {
      const year = academicYears.find((item) => String(item.id) === String(value));
      const options = getDataSemesterMap.filter((item) =>
        String(item.ysb_academic_year_id) === String(value) ||
        (year && String(item.name_year) === String(year.name_year))
      ).sort((a, b) => Number(a.semester) - Number(b.semester));
      const selected = options.find((item) => Number(item.status) === 1) || options[0];
      setSelectedAcademicYearId(value);
      setFormFilter((old) => ({ ...old, ysb_semester_id: selected?.id || "" }));
    } else {
      const reset = name === "ysb_branch_id"
        ? { ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "" }
        : name === "ysb_school_id"
        ? { ysb_grade_level_id: "", ysb_kelas_id: "" }
        : name === "ysb_grade_level_id" ? { ysb_kelas_id: "" } : {};
      if (name === "ysb_branch_id") setGetDataSchool([]);
      if (["ysb_branch_id", "ysb_school_id"].includes(name)) setGetDataLevel([]);
      if (["ysb_branch_id", "ysb_school_id", "ysb_grade_level_id"].includes(name)) setGetDataKelas([]);
      setFormFilter((old) => ({ ...old, [name]: value, ...reset }));
    }
    setIsFilterDirty(true);
    setHasSearched(false);
    setGetData([]);
    setDataWalas(null);
    setSelectedTab(null);
    setSearchKeyword("");
    setTablePage(1);
  };

  const handleCari = () => {
    if (!complete || isFetching) return;
    setSearchKeyword("");
    setTablePage(1);
    GetResponseData();
  };

  const switchSemester = (semester) => {
    if (!semester?.id || isFetching || String(formFilter.ysb_semester_id) === String(semester.id)) return;
    const cached = semesterDataCache.current[String(semester.id)];
    setFormFilter((old) => ({ ...old, ysb_semester_id: semester.id }));
    setGetData(cached?.students || []);
    setDataWalas(cached?.walas || []);
    setSearchKeyword("");
    setTablePage(1);
  };

  const filteredData = useMemo(() => {
    let rows = Array.isArray(getData) ? [...getData] : [];

    const searchValue = safeStr(searchKeyword)
      .trim()
      .toLowerCase();

    if (searchValue) {
      rows = rows.filter((student) => {
        const studentName = safeStr(
          student?.nama_siswa || student?.name_student
        ).toLowerCase();

        const nisn = safeStr(student?.nisn).toLowerCase();

        return (
          studentName.includes(searchValue) ||
          nisn.includes(searchValue)
        );
      });
    }

    rows.sort((a, b) => {
      const orderA =
        a?.order_absen === null ||
        a?.order_absen === undefined ||
        a?.order_absen === ""
          ? null
          : Number(a.order_absen);

      const orderB =
        b?.order_absen === null ||
        b?.order_absen === undefined ||
        b?.order_absen === ""
          ? null
          : Number(b.order_absen);

      const aHasOrder =
        orderA !== null && !Number.isNaN(orderA);

      const bHasOrder =
        orderB !== null && !Number.isNaN(orderB);

      if (!aHasOrder && bHasOrder) {
        return -1;
      }

      if (aHasOrder && !bHasOrder) {
        return 1;
      }

      if (aHasOrder && bHasOrder && orderA !== orderB) {
        return orderA - orderB;
      }

      const nameA = safeStr(
        a?.nama_siswa || a?.name_student
      );

      const nameB = safeStr(
        b?.nama_siswa || b?.name_student
      );

      const nameComparison = collator.compare(nameA, nameB);

      if (nameComparison !== 0) {
        return nameComparison;
      }

      return collator.compare(
        safeStr(a?.nisn),
        safeStr(b?.nisn)
      );
    });

    return rows;
  }, [collator, getData, searchKeyword]);

  const toTitleCase = (value) => {
    const text = safeStr(value).toLowerCase().trim();

    if (!text) {
      return "";
    }

    return text.replace(/\w\S*/g, (word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
  };

  const [dataUpdate, setDataUpdate] = useState();

  const viewModalUpdate = (assignmentId, student) => {
    setModalUpdate(true);
    setId(assignmentId);
    setDataUpdate(student);
  };

  void viewModalUpdate;

  // const totalRows = filteredData.length;

  // const totalPages = useMemo(() => {
  //   const pages = Math.ceil(
  //     totalRows / Math.max(1, rowsPerPage)
  //   );

  //   return pages <= 0 ? 1 : pages;
  // }, [totalRows, rowsPerPage]);

  // useEffect(() => {
  //   setTablePage(1);
  // }, [searchKeyword, getData]);

  // useEffect(() => {
  //   if (tablePage > totalPages) {
  //     setTablePage(totalPages);
  //   }

  //   if (tablePage < 1) {
  //     setTablePage(1);
  //   }
  // }, [tablePage, totalPages]);

  // const paginatedData = useMemo(() => {
  //   const safeRows = Math.max(1, rowsPerPage);
  //   const start = (tablePage - 1) * safeRows;

  //   return filteredData.slice(start, start + safeRows);
  // }, [filteredData, tablePage, rowsPerPage]);

  const totalPages = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));

  useEffect(() => {
    setTablePage((page) => Math.min(page, totalPages));
  }, [totalPages]);

  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;
    return filteredData.slice(start, start + safeRows);
  }, [filteredData, tablePage, rowsPerPage]);

  // const pageNumbers = useMemo(() => {
  //   const maxButtons = 5;
  //   const pages = [];

  //   if (totalPages <= maxButtons) {
  //     for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
  //       pages.push(pageNumber);
  //     }

  //     return pages;
  //   }

  //   const left = Math.max(1, tablePage - 1);
  //   const right = Math.min(totalPages, tablePage + 1);

  //   pages.push(1);

  //   if (left > 2) {
  //     pages.push("...");
  //   }

  //   for (let pageNumber = left; pageNumber <= right; pageNumber++) {
  //     if (pageNumber !== 1 && pageNumber !== totalPages) {
  //       pages.push(pageNumber);
  //     }
  //   }

  //   if (right < totalPages - 1) {
  //     pages.push("...");
  //   }

  //   pages.push(totalPages);

  //   return pages.filter(
  //     (value, index, array) => array.indexOf(value) === index
  //   );
  // }, [tablePage, totalPages]);

  // const goToPage = (nextPage) => {
  //   const selectedPage = Math.min(
  //     Math.max(1, Number(nextPage) || 1),
  //     totalPages
  //   );

  //   setTablePage(selectedPage);
  // };

  const viewModalSwitchStudent = (student) => {
    const currentSchool = getDataSchool.find(
      (item) => String(item.school_code) === String(formFilter.ysb_school_id)
    );
    const currentLevel = getDataLevel.find(
      (item) => String(item.id) === String(formFilter.ysb_grade_level_id)
    );
    const currentClass = getDataKelas.find(
      (item) => String(item.id) === String(formFilter.ysb_kelas_id)
    );

    setId(student?.ysb_student_id || student?.student_id || student?.id);
    setDataUpdate({
      ...student,
      ysb_student_id:
        student?.ysb_student_id || student?.student_id || student?.id || "",
      ysb_academic_year_id: selectedAcademicYearId,
      ysb_semester_id: formFilter.ysb_semester_id,
      ysb_branch_id: formFilter.ysb_branch_id,
      ysb_school_id: formFilter.ysb_school_id,
      ysb_grade_level_id: formFilter.ysb_grade_level_id,
      ysb_kelas_id: formFilter.ysb_kelas_id,
      name_student: student?.name_student || student?.nama_siswa || "",
      name_school: currentSchool?.school_name || "",
      name_level: currentLevel?.name_level || "",
      name_kelas: currentClass?.name_kelas || "",
    });
    setModalSwitchStudent(true);
  };


  return (
    <>
    {modalSwitchStudent && (
      <ModalSwitchStudent
        GetResponseData={GetResponseData}
        id={id}
        dataUpdate={dataUpdate}
        classes={getDataKelas}
        show={modalSwitchStudent}
        onHide={() => setModalSwitchStudent(false)}
      />
    )}

    {previewStudent && (
              <PreviewFoto student={previewStudent} show={true} onHide={() => setPreviewStudent(null)} />
            )}

      <div className="body sims-page">
        {modalLanjutSemester && Number(activeSemester?.semester) === 2 && (
          <LanjutSemesterModal
            onHide={() => setModalLanjutSemester(false)}
            onSaved={GetResponseData}
            semester={activeSemester}
            academicYear={activeAcademicYear}
            branches={getDataBranch}
            initialBranch={formFilter.ysb_branch_id}
            semesters={getDataSemesterMap}
          />
        )}
        {modalAdd && (
          <PromotionModal
            show={modalAdd}
            onHide={() => setModalAdd(false)}
            onSaved={GetResponseData}
            semesters={getDataSemesterMap}
            academicYears={academicYears}
            branches={getDataBranch}
            schools={getDataSchool}
            levels={getDataLevel}
            classes={getDataKelas}
            filters={formFilter}
          />
        )}

        {/* {modalUpdate && (
          <ModalUpdate
            GetResponseData={GetResponseData}
            id={id}
            dataUpdate={dataUpdate}
            show={modalUpdate}
            onHide={() => setModalUpdate(false)}
          />
        )} */}

        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faUserGraduate} />
              </span>

              <h4 className="page-title-text">
                Rombel
              </h4>
            </div>

            <div className="ml-auto" style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button
                type="button"
                onClick={() => setModalAdd(true)}
                className="btn btn-create sims-header-button"
              >
                {/* <FontAwesomeIcon icon={faPlus} /> */}
                <span>Atur Rombel / Naik Kelas</span>
              </button>
              {Number(activeSemester?.semester) === 2 && (
                <button type="button" className="btn  sims-header-button" style={{backgroundColor: "#f4aa33", color: "#fff"}}
                  onClick={() => setModalLanjutSemester(true)}>
                  Lanjut Semester 2
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="body-content sims-content">
          {loading ? (
            <div className="sims-filter-card">
              {Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={`filter-skeleton-${index}`}
                  className="shimmer sims-filter-skeleton"
                />
              ))}
            </div>
          ) : (
            <div className="sims-filter-card">
              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Tahun Ajaran
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_academic_year_id"
                  value={selectedAcademicYearId}
                  onChange={handleChange}
                >
                  <option value="" disabled>Pilih Tahun Ajaran</option>
                  {academicYears.map((year) => (
                    <option key={year.id} value={year.id}>
                      {year.name_year}{activeAcademicYear && String(year.id) === String(activeAcademicYear.id) ? " • Aktif" : ""}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Cabang
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_branch_id"
                  value={formFilter.ysb_branch_id}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Pilih Cabang
                  </option>

                  {getDataBranch.map((branch, index) => (
                    <option
                      key={branch?.branch_code || index}
                      value={branch?.branch_code}
                    >
                      {branch?.branch_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Sekolah
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_school_id"
                  value={formFilter.ysb_school_id}
                  onChange={handleChange}
                  disabled={
                    loadingSchool ||
                    !formFilter.ysb_branch_id
                  }
                >
                  <option value="" disabled>
                    {!formFilter.ysb_branch_id
                      ? "Pilih Cabang terlebih dahulu"
                      : loadingSchool
                      ? "Memuat data sekolah..."
                      : "Pilih Sekolah"}
                  </option>

                  {!loadingSchool &&
                    getDataSchool.map((school, index) => (
                      <option
                        key={school?.school_code || index}
                        value={school?.school_code}
                      >
                        {school?.school_name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Tingkatan
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_grade_level_id"
                  value={formFilter.ysb_grade_level_id}
                  onChange={handleChange}
                  disabled={
                    loadingLevel ||
                    !formFilter.ysb_school_id
                  }
                >
                  <option value="" disabled>
                    {!formFilter.ysb_school_id
                      ? "Pilih Sekolah terlebih dahulu"
                      : loadingLevel
                      ? "Memuat data tingkatan..."
                      : "Pilih Tingkatan"}
                  </option>

                  {!loadingLevel &&
                    getDataLevel.map((level, index) => (
                      <option
                        key={level?.id || index}
                        value={level?.id}
                      >
                        {level?.name_level}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Kelas
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_kelas_id"
                  value={formFilter.ysb_kelas_id}
                  onChange={handleChange}
                  disabled={
                    loadingKelas ||
                    !formFilter.ysb_grade_level_id
                  }
                >
                  <option value="" disabled>
                    {!formFilter.ysb_grade_level_id
                      ? "Pilih Tingkatan terlebih dahulu"
                      : loadingKelas
                      ? "Memuat data kelas..."
                      : "Pilih Kelas"}
                  </option>

                  {!loadingKelas &&
                    getDataKelas.map((kelas, index) => (
                      <option
                        key={kelas?.id || index}
                        value={kelas?.id}
                      >
                        {kelas?.name_kelas}
                      </option>
                    ))}
                </select>
              </div>

              <div className="sims-filter-action">
                <button
                  type="button"
                  onClick={handleCari}
                  disabled={!complete || !isFilterDirty || isFetching}
                  className="sims-filter-button"
                >
                  Tampilkan Data
                </button>
              </div>

              
            </div>
          )}

          {isFetching && (
            <div className="sims-loading">
              <PulseLoader color="#3f5bea" size={12}/>
            </div>
          )}

          {!filtersLoading && !isFetching && !hasSearched && isFilterDirty && (
            <div className="sims-empty-state">
              {complete ? "Silakan klik Tampilkan Data" : "Silakan lengkapi filter terlebih dahulu"}
            </div>
          )}

          {hasSearched && !isFilterDirty && !isFetching && (
            <>
              {dataWalas && (
                <div className="walas-card">
                  <div className="walas-card__title">
                    <span className="walas-card__icon">
                      <FontAwesomeIcon icon={faUserGraduate} />
                    </span>

                    <span>Wali Kelas</span>
                  </div>

                  <div className="walas-card__details">
                    <div className="walas-card__row">
                      <span className="walas-card__label">
                        Utama
                      </span>

                      <span className="walas-card__separator">
                        :
                      </span>

                      <span className="walas-card__name">
                        {dataWalas[0]?.nama_walas ||
                          "Belum ada wali kelas"}
                      </span>
                    </div>

                    <div className="walas-card__row">
                      <span className="walas-card__label">
                        Pendamping
                      </span>

                      <span className="walas-card__separator">
                        :
                      </span>

                      <span className="walas-card__name">
                        {dataWalas[1]?.nama_walas ||
                          "-"}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <div className="sims-table-tab-card ">

                <div className="sims-table-tab-head">
                  <div className="sims-table-tab-title">
                    <h5>{getDataLevel.find((item) => String(item.id) === String(formFilter.ysb_grade_level_id))?.name_level || "Tingkatan"} {getDataKelas.find((item) => String(item.id) === String(formFilter.ysb_kelas_id))?.name_kelas || "Kelas"} - Semester {selectedSemester?.semester || "-"}</h5>
                  </div>
                  <div className="sims-table-tab-semester-switch">
                    {semesterOptions.map((semester) => (
                      <button
                        type="button"
                        key={semester.id}
                        className={`sims-table-tab-semester ${String(formFilter.ysb_semester_id) === String(semester.id) ? "is-active" : ""}`}
                        onClick={() => switchSemester(semester)}
                        disabled={isFetching}
                      >
                        Semester {semester.semester}
                      </button>
                    ))}
                  </div>
                </div>


                <div className="sims-search-wrap mb-3 mt-3 px-2">
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="sims-search-icon"
                  />

                  <input
                    type="text"
                    className="sims-search-input"
                    placeholder="Cari nama siswa atau NISN..."
                    value={searchKeyword}
                    onChange={(event) =>
                      setSearchKeyword(event.target.value)
                    }
                  />
                </div>

                <div className="sims-table-tab-wrap ">
                  <div className="sims-table-tab sims-table-scroll">
                    <table className="sims-table">
                      <thead>
                        <tr>
                          <th className="sims-col-number">
                            No
                          </th>

                          <th style={{width: "100px"}}>
                            Foto
                          </th>

                          <th>
                            Nama Siswa
                          </th>

                          <th  style={{width: "150px"}}>
                            NISN
                          </th>

                          

                          <th>
                            Email
                          </th>

                          <th >
                            Aksi
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {paginatedData.length === 0 ? (
                          <tr>
                            <td
                              colSpan={6}
                              className="sims-empty-state"
                            >
                              <div className="sims-empty-state-content">
                                Data murid tidak ditemukan
                              </div>
                            </td>
                          </tr>
                        ) : (
                          paginatedData.map((student, index) => (
                            <tr
                              key={
                                student?.ysb_student_id ||
                                student?.id ||
                                `murid-${index}`
                              }
                            >
                              <td className="sims-col-number">
                                <span className="sims-number-badge">
                                  {(tablePage - 1) *
                                    rowsPerPage +
                                    index +
                                    1}
                                </span>
                              </td>

                            <td>
                              <button 
                                type="button" 
                                className="sims-photo-button"
                                title="Klik untuk melihat foto" 
                                onClick={() => setPreviewStudent(student)}
                                aria-label={`Lihat foto ${student?.nama_siswa || student?.name_student || "siswa"}`}
                              >
                                <StudentAvatar photo={studentPhoto(student)} />
                                <span className="sims-photo-zoom" aria-hidden="true">
                                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                                </span>
                              </button>
                            </td>
                            <td>
                                <span >
                                  {toTitleCase(
                                    student?.nama_siswa ||
                                      student?.name_student
                                  ) || "-"}
                                </span>
                              </td>

                              <td>
                                <span className="sims-text-bold">
                                  {student?.nisn || "-"}
                                </span>
                              </td>

                              

                              <td>
                                <span >
                                  {/* {toTitleCase(
                                    student?.nama_siswa ||
                                      student?.name_student
                                  ) || "-"} */}
                                  {student?.email || "-"}
                                </span>
                              </td>

                              <td>
                                 <button
                                      className="button-edit button-table text-center"
                                      onClick={() =>
                                        viewModalSwitchStudent(student)
                                      }
                                    >
                                      Pindah Kelas
                                    </button>

                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* {filteredData.length > 0 && (
                    <div className="sims-pagination">
                      <div className="sims-pagination-left">
                        <span className="sims-page-info">
                          Menampilkan{" "}
                          <b>
                            {Math.min(
                              (tablePage - 1) *
                                rowsPerPage +
                                1,
                              totalRows
                            )}
                          </b>
                          -
                          <b>
                            {Math.min(
                              tablePage * rowsPerPage,
                              totalRows
                            )}
                          </b>{" "}
                          dari <b>{totalRows}</b> data
                        </span>

                        <select
                          className="sims-page-size"
                          value={rowsPerPage}
                          onChange={(event) => {
                            const value =
                              Number(event.target.value) || 10;

                            setRowsPerPage(value);
                            setTablePage(1);
                          }}
                        >
                          <option value={10}>
                            10 data / halaman
                          </option>

                          <option value={25}>
                            25 data / halaman
                          </option>

                          <option value={50}>
                            50 data / halaman
                          </option>

                          <option value={100}>
                            100 data / halaman
                          </option>
                        </select>
                      </div>

                      <div className="sims-pagination-right">
                        <button
                          type="button"
                          className="sims-page-nav"
                          onClick={() =>
                            goToPage(tablePage - 1)
                          }
                          disabled={tablePage <= 1}
                        >
                          Sebelumnya
                        </button>

                        <div className="sims-page-numbers">
                          {pageNumbers.map(
                            (pageNumber, index) =>
                              pageNumber === "..." ? (
                                <span
                                  key={`dots-${index}`}
                                  className="sims-page-dots"
                                >
                                  ...
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  key={`page-${pageNumber}`}
                                  className={`sims-page-number ${
                                    pageNumber === tablePage
                                      ? "active"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    goToPage(pageNumber)
                                  }
                                >
                                  {pageNumber}
                                </button>
                              )
                          )}
                        </div>

                        <button
                          type="button"
                          className="sims-page-nav"
                          onClick={() =>
                            goToPage(tablePage + 1)
                          }
                          disabled={tablePage >= totalPages}
                        >
                          Selanjutnya
                        </button>
                      </div>
                    </div>
                  )} */}
                <Pagination
                  totalRows={filteredData.length}
                  tablePage={tablePage}
                  rowsPerPage={rowsPerPage}
                  onPageChange={setTablePage}
                  onRowsPerPageChange={(value) => {
                    setRowsPerPage(value);
                    setTablePage(1);
                  }}
                />
                </div>

              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
